import { formatISO, isValid, parseISO } from "date-fns"
import React, { useState } from "react"
import webify from "../util/webify"
import DatePicker from "./DatePicker"
import DatePickerWithPresets from "./DatePickerWithPresets"
import Label from "./Label"

interface TripDateFieldsProps {
  registrationGoal: number
  registrationLimit: number
  startDate: string
  endDate: string
  showCounts: boolean
  registrationClosesOn: string
  editingClosesOn: string
  hideRegistrationCloseDate: boolean
  errors: any
}

const TripDateFields = (props: TripDateFieldsProps) => {
  let { errors } = props

  let [startDate, setStartDate] = useState(parseISO(props.startDate))
  let [endDate, setEndDate] = useState(parseISO(props.endDate))
  let [editingClosesOn, setEditingClosesOn] = useState(parseISO(props.editingClosesOn))

  let [registrationGoal, setRegistrationGoal] = useState(props.registrationGoal)
  let [registrationLimit, setRegistrationLimit] = useState(props.registrationLimit)
  let [registrationClosesOn, setRegistrationClosesOn] = useState(parseISO(props.registrationClosesOn))
  let [isRegistrationCloseDateHidden, setIsRegistrationCloseDateHidden] = useState(props.hideRegistrationCloseDate)

  const currentMonth = () =>(isValid(startDate) ? startDate : new Date());

  return (
    <div className="form-grid-setup grid-cols-2 lg:grid-cols-12">
      
      <div className="lg:col-span-4">
        <Label
          label="Trip Starts"
          htmlFor="trip_start_date"
          required={true}
          error={errors["startDate"] && errors["startDate"][0]}
        ></Label>
          
        <DatePicker
          name="trip[start_date]"
          value={isValid(startDate) && formatISO(startDate, { representation: "date" })}
          fromYear={2018}
          toYear={2050}
          data-role="start-date"
          onChange={(date) => setStartDate(date)}
        />

        <div className="form-instructions">Date the trip starts.</div>
      </div>

      <div className="lg:col-span-4">
        <Label
          label="Trip Ends"
          htmlFor="trip_end_date"
          required={true}
          error={errors["endDate"] && errors["endDate"][0]}
        ></Label>

        <DatePicker
          name="trip[end_date]"
          value={isValid(endDate) && formatISO(endDate, { representation: "date" })}
          fromYear={2018}
          toYear={2050}
          data-role="end-date"
          onChange={(date) => setEndDate(date)}
          month={currentMonth()}
        />

        <div className="form-instructions">Return date of the trip.</div>
      </div>

      <div className="lg:col-span-4">
        <Label
          label="Editing Ends"
          htmlFor="trip_registration_closes_on"
          required={true}
          error={errors["registrationClosesOn"] && errors["registrationClosesOn"][0]}
        ></Label>

        {isValid(startDate) ? (
          <DatePickerWithPresets
            name="trip[editing_closes_on]"
            value={isValid(editingClosesOn) && formatISO(editingClosesOn, { representation: "date" })}
            label="When trip starts"
            relativeToDate={formatISO(startDate, { representation: "date" })}
            data-role="editing-closes-on"
            isValid={true}
            onChange={(date) => setEditingClosesOn(date)}
          ></DatePickerWithPresets>
        ) : (
          <DatePicker
            name="trip[editing_closes_on]"
            value={isValid(editingClosesOn) && formatISO(editingClosesOn, { representation: "date" })}
            fromYear={2018}
            toYear={2050}
            data-role="editing-closes-on"
            onChange={(date) => setEditingClosesOn(date)}
          />
        )}

        <div className="form-instructions">Passengers can't edit info after.</div>
      </div>

      <div className="lg:col-span-3">
        <Label
          label="Registration Ends"
          htmlFor="trip_registration_closes_on"
          required={true}
          error={errors["registrationClosesOn"] && errors["registrationClosesOn"][0]}
        ></Label>

        {isValid(startDate) ? (
          <DatePickerWithPresets
            name="trip[registration_closes_on]"
            value={isValid(registrationClosesOn) && formatISO(registrationClosesOn, { representation: "date" })}
            label="When trip starts"
            relativeToDate={formatISO(startDate, { representation: "date" })}
            data-role="registration-closes-on"
            isValid={true}
            onChange={(date) => setRegistrationClosesOn(date)}
          ></DatePickerWithPresets>
        ) : (
          <DatePicker
            name="trip[registration_closes_on]"
            value={isValid(registrationClosesOn) && formatISO(registrationClosesOn, { representation: "date" })}
            fromYear={2018}
            toYear={2050}
            data-role="registration-closes-on"
            onChange={(date) => setRegistrationClosesOn(date)}
          />
        )}

        <div className="form-instructions">Last day of registration.</div>
      </div>

      <div className="lg:col-span-3">
        <div className="label-component">
          <div className="label-styled flex">
            <label htmlFor="trip_hide_registration_close_date?">Registration Date</label>
          </div>
        </div>

        <select
          id="trip_hide_registration_close_date?"
          name="trip[hide_registration_close_date?]"
          onChange={() => setIsRegistrationCloseDateHidden(!isRegistrationCloseDateHidden)}
          value={isRegistrationCloseDateHidden.toString()}
        >
          <option value="false">Show to passengers</option>
          <option value="true">Hide from passengers</option>
        </select>
        <div className="form-instructions">Choose whether to display the registration end date to passengers</div>
      </div>
    </div>
  )
}

export default TripDateFields
webify("trip-date-fields", TripDateFields)
